// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"909e550c","455":"3e7e8090","519":"11529ef8","910":"6df568e5","977":"96a36a18"}[chunkId] + ".chunk.js";
};